export const FREEBIE_TEXT = "1 Free Delight for you";

export const ACCESSIBLITY_TEXTS = {
    FOOD_QUANTITY: "Quantity {0}",
    FINAL_PRICE: "Item Total {0} Rupees",
};

export enum BoldText {
    START = "[[",
    END = "]]",
}
